<template>
  <div>

    <div class="pxkeji-right-box">
      <pxkeji-btn name="添加章节" v-if="dataSourceType==2 || dataSourceType==0" class="pxkeji_basic_btn" @click="addzhangjie(0,1)" type="primary" />
      <pxkeji-btn name="添加课时" v-if="dataSourceType==2 || dataSourceType==1" class="pxkeji_basic_btn" @click="addks(0,0,1)" type="primary" />
      <a-table
        :columns="list.columns"
        rowKey="id"
        :dataSource="list.datas"
        :locale="{emptyText:'暂无数据'}"
        :loading="isloading"
        :pagination="false"
        @change="onChange"
      >
        <span slot="action" slot-scope="action">
          <pxkeji-btn name="编辑章节" size="small" v-if="dataSourceType==0&&action.parentId==0" @click="addzhangjie(action.id)" type="primary" />
          <!-- <pxkeji-btn name="编辑课时" size="small" v-else-if="dataSourceType==1" @click="addks(action.id,0,1)" type="primary" /> -->
          <a-divider type="vertical" v-if="dataSourceType==0&&action.parentId==0" />
          <pxkeji-btn name="添加课时" v-if="dataSourceType==0&&action.parentId==0" size="small" @click="addks(0,action.id,1)" type="primary" />
          <pxkeji-btn name="编辑课时" v-else size="small" @click="addks(action.id,action.chapterId,0)" type="primary" />
          <a-divider type="vertical" />
          <pxkeji-btn name="删除章节" v-if="dataSourceType==0&&action.parentId==0" size="small" @click="delInfo(action.id)" type="default" />
          <pxkeji-btn name="删除课时" v-else size="small" @click="deleteKs(action.id)" type="default" />
          <a-divider type="vertical" />
          <pxkeji-btn name="上移" size="small" @click="handlemoveup(action.id,action.dataSourceType)" type="default" />
          <a-divider type="vertical" />
          <pxkeji-btn name="下移" size="small" @click="handlemovedown(action.id,action.dataSourceType)" type="default" />
        </span>
      </a-table>
      <div class="totalbox" style="float: left;">
        <div>
<!--          <span>共有：{{list.pagination.total}}条数据</span>-->
        </div>
      </div>
    </div>

    <a-modal
      :title="zjInfo.title"
      v-model="zjInfo.visible"
      width="50%"
      :footer="false"
      destroyOnClose
      :maskClosable="false"
    >
      <zjInfo @callbackMethod="getaddzjInfo" :id="zjInfo.id" :zjId="zjInfo.zjId" />
    </a-modal>
    <!--添加课时-->
    <a-modal
      :title="ksInfo.title"
      v-model="ksInfo.visible"
      width="60%"
      :footer="false"
      destroyOnClose
      :maskClosable="false"
    >
      <ksInfo @callbackMethod="getaddksInfo" :id="ksInfo.id" :ksId="ksInfo.ksId" :zjid="ksInfo.zjid" />
    </a-modal>
  </div>
</template>
<script>
import zjInfo from "./addzjInfo.vue"; //章节
import ksInfo from "./addksInfo.vue";//课时

var that;
var columns = [
  {
    dataIndex: "title",
    key: "title",
    align: "left",
    title: "名称"
  },
  {
    key: "action",
    align: "right",
    title: "操作",
    scopedSlots: { customRender: "action" }
  }
];
export default {
  name: "columnlist",
  props: {
    id: String,
  },
  data() {
    return {
      expand: false, //高级搜索
      list: {
        columns, //表头
        datas: [], //数据
        pagination: {
          //分页器
          showQuickJumper: true,
          hideOnSinglePage: true,
          total: 0,
          current: 1, //页码
          defaultPageSize: 10 //页容
        }
      },
      isloading: false,
      zjInfo: {
        visible: false,
        id: 0,
        title: "",
        zjId: 0
      },
      zjlists: [],
      ksInfo: {
        visible: false,
        id: 0,
        title: "",
        ksId: 0,
        zjId: 0
      },
      dataSourceType: 2
    };
  },
  components: {
    zjInfo,
    ksInfo
  },
  mounted: function() {
    this.$nextTick(function() {
      that = this;
      // console.log('id',this.id)
      this.GetList();
      console.log(this.dataSourceType)
    });

  },
  watch: {
    selectRows: function() {
      //console.log("watch", val);
    }
  },
  methods: {
    GetList() {
      //获取列表
      this.isloading = true;
      this.$api.course
        .getChapterAndCoursehoursById(this.id)
        .then(res => {
          this.isloading = false;
          console.log(res.data.classhourList.length)
          if (res.errorCode == this.$msg.responseCode.success) {
            var dataSourceArr = [];
            console.log(res.data.classhourList.length)
            if(res.data.chapterInfoList.length>0) {
              // dataSourceArr.push(res.data.chapterInfoList);
              res.data.chapterInfoList.forEach(function(item, index) {
                //2021 11 08 start
                item.dataSourceType=0;
                if(item.children.length > 0){
                   item.children.forEach(function(obj, i) {
                      item.children[i].dataSourceType=1;
                   });
                }
                //2021 11 08 end
                dataSourceArr.push(item);
              });
              this.dataSourceType = 0;
            }else if(res.data.classhourList.length>0) {
              // dataSourceArr.push(res.data.classhourList)
              console.log(111)
              res.data.classhourList.forEach(function(item, index) {
                item.dataSourceType=1;//2021 11 08
                dataSourceArr.push(item);
              });
              this.dataSourceType = 1;
            }
            // this.list.datas = res.data.chapterInfoList;
            this.list.datas = dataSourceArr;
            // console.log(res.data.chapterInfoList);
            // console.log(res.data.classhourList);
             console.log(dataSourceArr)
          } else {
            that.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    onChange(page) {
      //页面切换回调
      this.list.pagination.current = page.current;
      this.GetList();
    },
    //查看订单
    // showInfo(id) {
    //   this.info.title = id ? "编辑" : "新增";
    //   this.info.visible = true;
    //   this.info.id = id;
    // },

    //子组件传值
    // save() {
    //   this.zjInfo.visible = false;
    //   this.GetList();
    // },
    close() {
      this.$confirm({
        title: "提示",
        content: "您确定要禁用么",
        okText: "确认",
        cancelText: "取消"
      });
    },
    delInfo(id) {
      this.$confirm({
        title: "您确定要删除此项吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {
          that.isloading = true;
          that.$api.course
            .deleteChapter(id)
            .then(res => {
              that.isloading = false;
              if (res.errorCode == that.$msg.responseCode.success) {
                that.$message.success(res.errorMsg);
                that.GetList();
              } else {
                that.$message.error(res.errorMsg);
              }
            })
            .catch(() => {
              that.isloading = false;
            });
        },
        onCancel() {
          //console.log("Cancel");
        }
      });
    },
    deleteKs(id) {
      this.$confirm({
        title: "您确定要删除此项吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {
          that.isloading = true;
          that.$api.classhour
            .deleteKs(id)
            .then(res => {
              that.isloading = false;
              if (res.errorCode == that.$msg.responseCode.success) {
                that.$message.success(res.errorMsg);
                that.GetList();
              } else {
                that.$message.error(res.errorMsg);
              }
            })
            .catch(() => {
              that.isloading = false;
            });
        },
        onCancel() {
          //console.log("Cancel");
        }
      });
    },
    /**添加章节 */
    addzhangjie(id,type) {

      if(type==1){
        this.zjInfo.title='添加';
      }else{
        this.zjInfo.title='编辑';
      }
      this.zjInfo.visible = true;
      this.zjInfo.id = this.id;
      this.zjInfo.zjId = id;
    },
    getaddzjInfo(data) {
      this.zjInfo.visible = false;
      this.GetList();
    },
    /**添加课时 **/
    addks(id,zjid,type){
      if(type==1){
        this.ksInfo.title='添加';
      }else{
        this.ksInfo.title='编辑';
      }
      if(zjid==0) {
        this.ksInfo.zjid=0;
      }else {
        this.ksInfo.zjid = zjid;
        console.log(this.ksInfo.zjid)
      }
      this.ksInfo.visible = true;
      this.ksInfo.id = this.id;
      this.ksInfo.ksId = id;
    },
    getaddksInfo(data) {
      this.ksInfo.visible = false;
      this.GetList();
    },
    /**上移下移 */
    handlemoveup(id,type) {
      this.isloading = true;
      this.$api.course
          .sortData(id,type,1,this.id)
          .then(res => {
            this.isloading = false;
            if (res.errorCode == that.$msg.responseCode.success) {
              var dataSourceArr = [];
              if(res.data.chapterInfoList.length>0) {
                res.data.chapterInfoList.forEach(function(item, index) {
                  //2021 11 08 start
                  item.dataSourceType=0;
                  if(item.children.length > 0){
                    item.children.forEach(function(obj, i) {
                      item.children[i].dataSourceType=1;
                    });
                  }
                  //2021 11 08 end
                  dataSourceArr.push(item);
                });
                // this.dataSourceType = 0;
              }else if(res.data.classhourList.length>0) {
                res.data.classhourList.forEach(function(item, index) {
                  item.dataSourceType=1;//2021 11 08
                  dataSourceArr.push(item);
                });
                // this.dataSourceType = 1;
              }
              that.list.datas = dataSourceArr;
            } else {
              that.$message.error(res.errorMsg);
            }
          })
          .catch(() => {
            this.isloading = false;
          });

    },
    handlemovedown(id,type) {
      this.isloading = true;
      this.$api.course
          .sortData(id,type,0,this.id)
          .then(res => {
            this.isloading = false;
            if (res.errorCode == that.$msg.responseCode.success) {
              var dataSourceArr = [];
              if(res.data.chapterInfoList.length>0) {
                res.data.chapterInfoList.forEach(function(item, index) {
                  //2021 11 08 start
                  item.dataSourceType=0;
                  if(item.children.length > 0){
                    item.children.forEach(function(obj, i) {
                      item.children[i].dataSourceType=1;
                    });
                  }
                  //2021 11 08 end
                  dataSourceArr.push(item);
                });
                // this.dataSourceType = 0;
              }else if(res.data.classhourList.length>0) {
                res.data.classhourList.forEach(function(item, index) {
                  item.dataSourceType=1;//2021 11 08
                  dataSourceArr.push(item);
                });
                // this.dataSourceType = 1;
              }
              that.list.datas = dataSourceArr;
            } else {
              that.$message.error(res.errorMsg);
            }
          })
          .catch(() => {
            this.isloading = false;
          });
    },
    /**添加课时 */

    error(msg) {
      this.$error({
        title: "提示",
        content: msg == undefined ? "服务器异常" : msg,
        okText: "返回",
        centered: true,
        onOk() {
          that.$emit("callbackMethod");
        }
      });
    }
  }
};
</script>

<style>
.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

#components-form-demo-advanced-search .ant-form {
  max-width: none;
}

#components-form-demo-advanced-search .search-result-list {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  text-align: center;
  padding-top: 80px;
}

.cang_sta {
  text-align: center;
}

.cang_sta img {
  width: 35px;
}
</style>

